<template>
  <div class="config-menu">
    <emat-block
      :name="$t('ChargingStationMenu.charging_station_configuration')"
      style="margin: 0 auto;"
      :style="device === 'mobile' ? {minWidth: '100%'} : {maxWidth: '320px'}"
    >
      <EmatBlockItem
        :label="$t('global.label.power')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_power')"
        style="padding: 18px 15px 14px;"
      >
        <EmatTabs
          :tabs="powers"
          v-model="power"
        />
      </EmatBlockItem>
      <EmatBlockItem
        :label="$t('global.label.start/stop')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_system')"
        style="padding: 15px 15px 14px;"
      >
        <EmatSelect
          :class="device"
          name="input-name"
          v-model="system"
          :options="systems"
        />
      </EmatBlockItem>

      <EmatBlockItem
        :label="$t('ChargingStationMenu.charging_method')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_method')"
        style="padding: 18px 15px 14px;"
      >
        <EmatTabs
          :tabs="methods"
          v-model="method"
        />

        <EmatTabs
          v-if="currentMethod && currentMethod.with_plugs"
          :tabs="plugs"
          v-model="plug"
        />
      </EmatBlockItem>


      <EmatBlockItem
        :label="$t('global.label.color')"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_color')"
        style="padding: 18px 15px 14px;"
      >
        <EmatTabs
          :tabs="colors"
          v-model="color"
        />
      </EmatBlockItem>

      <EmatBlockItem
        v-if="currentSystem.disable_socket === 0"
        :info-popup="$store.getters['infoPopup/findByKey']('charging_station_socket')"
        style="display: flex; padding: 15px 15px 13px;"
      >
        <EmatCheckbox
            name="input-name"
            :label="type.sockets[0].name"
            :disabled="true"
            v-model="socket"
            :extra-label="getExperimentVariant('p0ht7U2BRtK5oXDPk9U2zA') === 0 ? ('+' + type.sockets[0].price.toFixed(2)) : null"
        />
      </EmatBlockItem>
    </emat-block>
    <ProductsBlock />
  </div>
</template>

<script>
import EmatBlock from 'Components/Layout/Block';
import EmatSelect from 'Components/Inputs/Select';
import EmatTabs from 'Components/Inputs/Tabs';
import EmatInfo from 'Components/General/Info';
import EmatBlockItem from 'Components/Layout/BlockItem';
import EmatCheckbox from 'Components/Inputs/Checkbox';
import { mapState, mapGetters } from 'vuex';
import updateSettingMixin from '@/mixins/updateSettingMixin';
import ProductsBlock from './ProductsBlock';

export default {
  name: 'ChargingStationMenu',

  mixins: [updateSettingMixin],

  components: {
    EmatBlock,
    EmatBlockItem,
    EmatTabs,
    EmatInfo,
    EmatSelect,
    EmatCheckbox,
    ProductsBlock,
  },

  props: {
    type: {
      type: Object,
      required: true,
    },
  },
  methods: {
    updateBuild(prop, val) {
      this.$store.dispatch('build/change' + prop, { value: val });
    },
    hasItems(items) {
      return Object.keys(items).every(function(key) {
        return items[key].length !== 0;
      });
    },
    sortAlphabetically(a, b) {
        let labelA = parseInt(a.label.replace('m', ''));
        let labelB = parseInt(b.label.replace('m', ''));
        return (labelA > labelB) - (labelA < labelB);
    }
  },
  computed: {
    plug: {
      get() { return this.$store.state.build.plug;},
      set(val) { this.updateBuild('Plug', val);},
    },
    power: {
      get() { return this.$store.state.build.power;},
      set(val) {
        this.updateBuild('Power', val);
        this.updateSetting();
      },
    },
    system: {
      get() { return this.$store.state.build.system;},
      set(val) { this.updateBuild('System', val);},
    },
    method: {
      get() { return this.$store.state.build.method;},
      set(val) { this.updateBuild('Method', val);},
    },
    currentMethod() {
      return this.$store.getters['methods/getById'](this.method);
    },
    color: {
      get() { return this.$store.state.build.color;},
      set(val) { this.updateBuild('Color', val);},
    },
    socket: {
      get() { return this.$store.state.build.socket;},
      set(val) { this.updateBuild('Socket', val);},
    },
    setting: {
      get() { return this.$store.state.build.setting;},
      set(val) { this.updateBuild('Setting', val);},
    },
    ...mapState({
      typesAll: state => state.types.all,
    }),
    ...mapGetters({
      types: 'types/mappedById',
      allMethods: 'methods/all',
      allPlugs: 'methods/plugs',
      device: 'getDevice',
      getExperimentVariant: 'ABTesting/getExperimentVariant',
    }),
    colors() {
      return this.type.colors.map((c) => {
        return { id: c.id, label: c.name };
      });
    },

    systems() {
      return this.type.systems.sort((a, b) => {
        return a.sort - b.sort;
      }).map((c) => {
        return {
          id: c.id,
          label: c.name,
          extra: this.getExperimentVariant('p0ht7U2BRtK5oXDPk9U2zA') === 0 ?
            (c.default ? this.$t('global.label.standard') : ('+' + c.price.toFixed(2))) :
            null,
          value: c.id,
        };
      });
    },

    currentSystem() {
      return this.type.systems.find(system => system.id === this.system);
    },

    settings() {
      let power = this.$store.getters['types/chosenProperty']('powers', this.$store.state.build.power);

      return (power && power.settings.length > 0) ? power.settings.map((c) => {
        return { id: c.id, label: c.name, value: c.id };
      }) : [];
    },
    methods() {
      let plug;
      if (this.plug) {
        plug = this.allPlugs.find(plug => plug.id === this.plug);
      }
      if (plug.name === 'Type 1') {
        return this.allMethods
          .filter(method => method.name === '5m' || method.name === '8m' || method.name === 'WCD')
          .map((method) => {
            return { id: method.id, label: method.name, extra: method.extra_name, withPlugs: method.with_plugs };
          })
          .sort(this.sortAlphabetically);
      }
      return this.allMethods.map((method) => {
        return { id: method.id, label: method.name, extra: method.extra_name, withPlugs: method.with_plugs };
      }).sort(this.sortAlphabetically);
    },
    plugs() {
      if (this.currentMethod.name === '3m' || this.currentMethod.name === '12m') {
        return this.allPlugs.filter(plug => plug.name === 'Type 2').map((plug) => {
          return { id: plug.id, label: plug.name, value: plug.id };
        });
      }
      return this.allPlugs.map((plug) => {
        return { id: plug.id, label: plug.name, value: plug.id };
      });
    },
    powers() {
      return this.type.powers.map((c) => {
        return { id: c.id, label: c.name };
      });
    },
  },
  watch: {
    typesAll: {
      deep: true,
      handler(val) {
        // console.log('being watched')
      },
    },
  },
};
</script>

<style scoped lang="scss">
.config-menu {
  margin-top: 11px;

  .component-block-holder {
    .component-block {
      padding: 10px 15px;
      border-top: 1px solid #e7e7e7;
      background-color: #fafafa;
      text-align: left;

      .flex {
        display: flex;
        align-items: center;

        .sub-label {
          font-family: AntennaCond, sans-serif;
          font-size: 10px !important;
          color: rgba(0, 0, 0, .5);
          line-height: 1;
          width: 50%;
          margin-top: -5px;
        }
      }

      .info-popup {
        margin-top: 4px;
        position: relative;

        .info-icon {
          margin-right: 15px;
          cursor: pointer;
        }
      }

      .select-box {
        margin: 9.5px 0;
        position: relative;
        flex-grow: 1;
        background: #fff;
        border: 1px solid #d7dae2;
        user-select: none;
        box-shadow: 0 2px 3px rgba(0, 0, 0, .05);
        min-height: 32px;

        .value {
          padding-top: 8px;
          padding-bottom: 4px;
          display: flex;
          justify-content: space-between;
          position: relative;
          height: 32px;
          box-sizing: border-box;
          transition: background .3s ease;
          flex-shrink: 1;

          &.current-value {
            background: #fff;
            padding-left: 13px;
            padding-right: 28px;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;

            img {
              position: relative;
              left: 20px;
            }
          }
        }

        .name {
          font-size: 13px;
          line-height: 17px;
          transition: color .3s ease;
          color: #424140;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding-right: 5px;
        }

        .price {
          font-size: 10px;
          color: rgba(0, 0, 0, .3);
          font-weight: 700;
          display: block;
        }
      }
    }
  }
}
</style>
